import { List, Record } from 'immutable';
import InventoryRecord from './InventoryRecord';

const SimilarProductsCategoryDefaults = {
  header: null,
  inventory_record_id: null,
  inventory_records: new List()
};

class SimilarProductsCategory extends Record(SimilarProductsCategoryDefaults) {
  constructor(values) {
    values.inventory_records = (new List(values.inventory_records)).map((inventoryRecord) => {return (inventoryRecord instanceof InventoryRecord ? inventoryRecord : new InventoryRecord(inventoryRecord));});

    super(values);
  }
}

export default SimilarProductsCategory;



// WEBPACK FOOTER //
// banquet/models/SimilarProductsCategory.js